module.exports = __webpack_public_path__ + "static/img/input.a4446fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/input.svg
// module id = rm/7
// module chunks = 0